import React, { useCallback } from 'react'
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs'
import ReactTooltip from 'react-tooltip'
import { ProgressBar } from 'react-step-progress-bar'

import 'react-step-progress-bar/styles.css'

import { formatDate } from './../utils'

const arrayPageSize = 5

const DetailsTimeline = props => {
  const { timeline } = props
  const [arrayPageActual, setArrayPageActual] = React.useState(1)

  const arrayPaginate = useCallback(
    pageNumber => {
      return timeline.slice(
        (pageNumber - 1) * arrayPageSize,
        pageNumber * arrayPageSize
      )
    },
    [timeline]
  )

  React.useEffect(() => {
    arrayPaginate(1)
  }, [timeline, arrayPaginate])

  const arrayTotalPages = React.useMemo(() => {
    const totalPagesTemp = parseFloat(
      (timeline.length - 1) / arrayPageSize
    ).toFixed(0)
    const arrayEmpty = new Array(parseInt(totalPagesTemp)).fill(0)
    return arrayEmpty
  }, [timeline])

  const arrayPorcentage = React.useMemo(() => {
    if (arrayTotalPages.length === 0) {
      return 0
    }

    if (arrayPageActual === 1) {
      return 0
    }

    if (arrayPageActual === arrayTotalPages.length) {
      return 100
    }

    return parseFloat((arrayPageActual / arrayTotalPages.length) * 100).toFixed(
      0
    )
  }, [arrayPageActual, arrayTotalPages])

  const paginateGo = type => {
    if (type === 'foward') {
      if (arrayPageActual <= arrayTotalPages.length - 1) {
        setArrayPageActual(arrayPageActual + 1)
      }
    } else {
      if (arrayPageActual > 0) {
        setArrayPageActual(arrayPageActual - 1)
      }
    }
    arrayPaginate(arrayPageActual)
  }

  return (
    <div className='row justify-content-start timeline-base col-12 no-gutters'>
      <ReactTooltip />

      <div className='timeline-content col-12 row justify-content-start no-gutters'>
        {arrayPaginate(arrayPageActual).map((item, key) => {
          return (
            <div className='timeline-item col-auto' key={key}>
              <div className='timeline-container'>
                <div className='timeline-desc'>{item.title}</div>
                <div className='timeline-date'>{formatDate(item.date)}</div>
              </div>
              <div className='timeline-line'>
                {/* <AiOutlineDash size={20} /> */}
                {/* <span className="timeline-circle" /> */}
                {/* <AiOutlineDash size={20} /> */}
              </div>
            </div>
          )
        })}
      </div>

      <div className='timeline-toolbar col-12 row justify-content-center no-gutters'>
        <div className='col-10' style={{ marginTop: '30px' }}>
          <ProgressBar
            percent={arrayPorcentage}
            filledBackground='linear-gradient(to right, #00b07d, #9aca3c)'
          />
        </div>
        <div className='col-2 text-center' style={{ marginTop: '10px' }}>
          <div className='btn-group' role='group'>
            <button
              className='btn btn-outline-dark btnTimeline'
              data-tip='Voltar Andamentos'
              onClick={() => paginateGo('back')}
              disabled={arrayPageActual === 1}
            >
              <BsArrowLeftShort size={20} />
            </button>

            <button
              className='btn btn-outline-dark btnTimeline'
              data-tip='Avançar Andamentos'
              onClick={() => paginateGo('foward')}
              disabled={arrayPageActual === arrayTotalPages.length}
            >
              <BsArrowRightShort size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DetailsTimeline
